import { Equals, IsNotEmpty, IsString } from 'class-validator';
import { UserEmailTokenVaultActions } from './token-vault-actions.enum';

export class UserActionTokenEmailDto {
  @IsString()
  @IsNotEmpty()
  @Equals(UserEmailTokenVaultActions.USER_CHANGE_EMAIL)
  action!: UserEmailTokenVaultActions.USER_CHANGE_EMAIL;

  @IsString()
  @IsNotEmpty()
  token!: string;
}
